// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__Db-Hl","rows":"style_rows__2lPY6","row":"style_row__2HIcd","embeddedForms":"style_embeddedForms__3WW5Y"};